// Mock data for trending collections
export const trendingCollections = [
  
  {
    id: "pudgypenguins",
    name: "PudgyPenguins",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fbafybeia7qfyvgwfxkhwjoorxqe6nezjk7jqv3bblo4cbs4hpjcecnky4vy.ipfs.w3s.link%2FIMG_6833.png",
    floorPrice: 10.41,
    priceChange: -0.74,
    volumeChange: -13.18,
    volume24h: 245.8,
    totalVolume: 2415.47,
    owners: 5058,
    supply: 8888
  },
  {
    id: "azuki",
    name: "Azuki",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGpnDPPI%252BsrhYBKQuBYc6XZMHTg6SSHih%252BOpmF%252FwAS4qY4NdVw4CAhgA1Wbpkx5GEXUwbgPcTN51MGZZWQi4%252FXlqxGoEDq%252FdAAlbOf2MwsZeMqMtUcF4j9cSCSDQMIVxbE%252FH2GQQzLcaEiWTS7%252Br1jEJDCE%252BYyhgHNXRacqbg83%252ByxJPUwfNMrixZnYzXFGecg%253D%253D",
    floorPrice: 3.22,
    priceChange: -3.82,
    volumeChange: 25.45,
    volume24h: 156.8,
    totalVolume: 1876.32,
    owners: 4892,
    supply: 10000
  },
  {
    id: "lilpudgys",
    name: "LilPudgys",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fbafybeicj5occh26bnn6eyvysll7sta2idw2t6b6xb6gbhgxuqcyf4dsbg4.ipfs.w3s.link%2FIMG_8872.png",
    floorPrice: 1.15,
    priceChange: -1.74,
    volumeChange: 14.56,
    volume24h: 56.2,
    totalVolume: 2203.36,
    owners: 9463,
    supply: 21888
  },
  {
    id: "milady",
    name: "Milady",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAIsk67N5jMstbeYGavsUixYM%252BZkA%252FyrzteG9PCFty%252BwNATyQ3RbaWJ1ltpLcAmGfl3KyswL%252FpDH%252BzCKCVV0EVFUB8h4G78qXOE2jLt7T0gP85tCRrR9NZ7bS56eofZmzX%252B81bxyCtBRKcgGJfhp3vklrsllcSTlAtUmNiziejsgpF0iBa8KGR5ePXytZU6f3dw%253D%253D",
    floorPrice: 4.39,
    priceChange: 3.55,
    volumeChange: 50.00,
    volume24h: 0,
    totalVolume: 5907.16,
    owners: 5441,
    supply: 9977
  },
  {
    id: "azuki-elementals",
    name: "Azuki Elementals",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAPzWajwX7U5rpGzNDDMgbjMSyOPU%252BGb1FL%252FuoinS78Xcw89y7UE7B9Jqv0Kvvgaq0orQ72S26uWUXm%252BNKQmOxELU7KhK3YvhfZrHc4NpoFrWxKNSwjPyiGr1Lfo%252B7Kuk5w%253D%253D",
    floorPrice: 0.29,
    priceChange: -5.52,
    volumeChange: -73.94,
    volume24h: 0.78,
    totalVolume: 5521.70,
    owners: 6147,
    supply: 17491
  },
  {
    id: "mutant-ape-yacht-club",
    name: "MutantApeYachtClub",
    image: "https://i.seadn.io/gae/lHexKRMpw-aoSyB1WdFBff5yfANLReFxHzt1DOj_sg7mS14yARpuvYcUtsyyx-Nkpk6WTcUPFoG53VnLJezYi8hAs0OxNZwlw6Y-dmI?auto=format&w=256",
    floorPrice: 2.28,
    priceChange: 1.85,
    volumeChange: 10.99,
    volume24h: 2.39,
    totalVolume: 870.58,
    owners: 11864,
    supply: 19541
  },
  {
    id: "doodles",
    name: "Doodles",
    image: "https://i.seadn.io/gae/7B0qai02OdHA8P_EOVK672qUliyjQdQDGNrACxs7WnTgZAkJa_wWURnIFKeOh5VTf8cfTqW3wQpozGedaC9mteKphEOtztls02RlWQ?auto=format&w=256",
    description: "The collectibles that started it all. Doodles Original Collection features 10,000 characters created by Co-Founder and renowned artist, Burnt Toast. The generative art was designed with a joyful range of colors, traits and personalities, with 32 hand-drawn, unique, 1 of 1's to round out the set.",
    floorPrice: 4.30,
    priceChange: 3.13,
    volumeChange: 6.82,
    volume24h: 0,
    totalVolume: 1537.95,
    owners: 3979,
    supply: 9998
  },
  {
    id: "beanz",
    name: "BEANZ",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAEYz3NvhBUqFaczju6etp8BohN6wAF67FtoJ%252FkNsmZYX5nx5wzpYwia4xMNgdDitnAaU4hFEzV9PlNr2XpIfVTS0NsvzwDPNIC89YNgSczlgvDdwl0q84AQcreBCGKnuWc%252FxoauDqSuRWlOwubpC0Iew8HIX%252FEVLtbD109nbb%252F2god5W%252FoI5VTvJ6Vk0ACqJoQ%253D%253D",
    floorPrice: 0.15,
    priceChange: -2.20,
    volumeChange: -42.86,
    volume24h: 0.32,
    totalVolume: 1876.32,
    owners: 4892,
    supply: 10000
  },
  {
    id: "boredapeyachtclub",
    name: "BoredApeYachtClub",
    image: "https://i.seadn.io/gae/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB?auto=format&w=256",
    floorPrice: 14.39,
    priceChange: 1.58,
    volumeChange: -2.47,
    volume24h: 14.50,
    totalVolume: 2019.75,
    owners: 5498,
    supply: 9999
  },
  {
    id: "jirasan",
    name: "Jirasan",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAKM5v2dthdDNgoFYsopVhfXPuqpXuK7ySj4SNzu4%252FGIM%252B%252Bdom99HWoelXoWfdqaPms3X4sZXSjoNfati%252Bp43vGY4JhrXVHDYB38zKsmUkvKyxWWwDywP%252F8vMSjb0yuKonw%253D%253D",
    floorPrice: 0.46,
    priceChange: -0.50,
    volumeChange: -2.96,
    volume24h: 0,
    totalVolume: 279.22,
    owners: 2320,
    supply: 10000
  },
  {
    id: "redacted-remilio-babies",
    name: "Redacted Remilio Babies",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAH9jsgKZBvWDCtYKUII0XUGE72IfvdT0oD5oUMTIR%252BGD63r%252FFCSdrPrHDHk26loi4th9yA%252BBpqtuzyoofnhZguL3s%252BOoW8eIZ08jD5e026Iom6uYet6736uOMuZDGAvaqg%253D%253D",
    floorPrice: 0.82,
    priceChange: -1.15,
    volumeChange: 23.74,
    volume24h: 41.63,
    totalVolume: 850.55,
    owners: 4490,
    supply: 5555
  },
    {
    id: "mocaverse",
    name: "Mocaverse",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAH6aHS6qyhvfdcldZtcEkEWNfwk4%252BaD42cbpN2fMnXc5jxlrOmLG8HYi2lHufjQS1QgQN%252Ba0w7ZHogXptM8jZssPiBczHtbkq0TXy%252BAbv6wqe8f0eMGGg4jbIM6ZO9nNXw%253D%253D",
    floorPrice: 2.18,
    priceChange: -6.11,
    volumeChange: -7.86,
    volume24h: 0,
    totalVolume: 107.00,
    owners: 2286,
    supply: 8888
  },
  {
    id: "bit-bears",
    name: "Bit Bears",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuALcgg3QHZ9oq4Bzp1AAfNgaUEQ9IfTpD2khnCi%252BtubRPY1XNRw2JJdux13amSaK1bk0srdiBo0wu0hCPLS37ZHAdeC5ng3CExsEVjy%252FfcyAofurrm3h0xLS%252FoChEy1kkig%253D%253D",
    floorPrice: 4.50,
    priceChange: -0.56,
    volumeChange: -3.32,
    volume24h: 6.55,
    totalVolume: 276.91,
    owners: 1089,
    supply: 2288
  },
  {
    id: "kanpai-pandas",
    name: "Kanpai Pandas",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAM3eNK3xiXW8HXZD5%252FX0yUrcFPuKOsEMLuMN4bZ%252FJuwZqNvbXNy18l%252Bik11riNVAoNDtt2GK7eeFfHrxOLkezOU7qJaWKtFuPY3xPwjyZmJaFasyFw57e2NT5OpZZrRf3w%253D%253D",
    floorPrice: 0.52,
    priceChange: -2.72,
    volumeChange: -18.14,
    volume24h: 1.91,
    totalVolume: 142.59,
    owners: 3112,
    supply: 8103
  },
  {
    id: "sappy-seals",
    name: "Sappy Seals",
    image: "https://pbs.twimg.com/profile_images/1565488723315380224/DCFh4o1x_400x400.jpg",
    floorPrice: 0.72,
    priceChange: -8.64,
    volumeChange: -23.23,
    volume24h: 0,
    totalVolume: 164.06,
    owners: 2160,
    supply: 9997
  },
  {
    id: "sproto-gremlins",
    name: "Sproto Gremlins",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuACpOLJDz1F4wV2LXYOjDJd4hQ5R3%252BGSsbskdRr92%252FRVEAPIHHjAP5jB9Cr%252BgQ8zNhtiVkYT0uNhKvrcJjzGPp31MvsvZ0UBw40mSVTcVTO8L6dikT1gS8amdA4HENUfFDA%253D%253D",
    floorPrice: 1.15,
    priceChange: -0.30,
    volumeChange: -15.37,
    volume24h: 0,
    totalVolume: 57.53,
    owners: 1512,
    supply: 3329
  },
  {
    id: "cryptodickbutts-s3",
    name: "CryptoDickbutts S3",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAMrWU66RPkZ9rgKPvWeO970XTUvAIqdBCBOOKG9KH4LJTKCQU9ADm39LpAl8EhjCQXspn0da0PN8ZYZDzb%252BBmRoqD9NvFB27ct1eFYJSzohlrZs39m%252B61qf%252BEeWN4hRM2z0m8QEwKa9Cl9Q4D1K70Qtv2NOHB%252BwHzHzUKdjXBC5SRoMApZvvFZe4LVtZcTdZ%252FQ%253D%253D",
    floorPrice: 0.97,
    priceChange: -5.26,
    volumeChange: -27.07,
    volume24h: 0,
    totalVolume: 75.43,
    owners: 2006,
    supply: 5198
  },
  {
    id: "creepz-by-overlord",
    name: "Creepz by OVERLORD",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGWMlxciEQCESPKStAj21DoWGPdanIKW7%252BUS788E3S4rr0vZtLulIV9OaZh44AlF0TUBeMht1PGSZieiyJRtvrBHnR9K2kTkfMhmGNzfG0yDbQAYL83JFf9a0DXwTRRjXw%253D%253D",
    floorPrice: 2.12,
    priceChange: -5.96,
    volumeChange: -2.80,
    volume24h: 0,
    totalVolume: 118.25,
    owners: 2356,
    supply: 10447
  },
  {
    id: "infinigods",
    name: "InfiniGods",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuALHKDz1OKxsdC3s2NKQhLza6EiPU%252B75E5VLADzlIL7i%252FHKuM08rSJjp%252F6v9VxinuUzXbVs9OPJ2vPQrk4%252BN661GRGQQxfg8XWM%252FX8NB%252BVmyiPiDRu5Qj6A5VctRv%252FWzFxg%253D%253D",
    floorPrice: 0.07,
    priceChange: -9.10,
    volumeChange: -73.15,
    volume24h: 0,
    totalVolume: 125.42,
    owners: 655,
    supply: 3448
  },
  {
    id: "cool-cats",
    name: "Cool Cats",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuABwxFrYu%252FAVx2g8hAylFyVOqN1w9GmQHpFm0EQ25HGbnYDpEmfOyJD%252FpoylyCXLP3GCQfi%252BEDnvk0dFmGqiB989cs1hQv4bg6Gfwm1C7al33DdnOxcHf%252FbIfHzCvEutZ9Tu%252FqqTBrZvwwN5KVtsJcgLQvXrcaze9FgK3YkoQyrWvOMIJdOSDwG%252FhJT303%252F8Hsw%253D%253D",
    floorPrice: 0.45,
    priceChange: -13.83,
    volumeChange: -17.56,
    volume24h: 0,
    totalVolume: 91.53,
    owners: 5516,
    supply: 9968
  },
  {
    id: "potatoz",
    name: "Potatoz",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAAIHtaNew1KwzY5SIze1be7UagisPdAfci7Z5l65lXw3hwp7IrNnpPMUxfIVChmikhmLn9%252BvIU6zZtBEwyuE8C4UW0m0PnxQ7WQw9rNkQsCbkTd8cDt6hxkk2CJ6pe1LGQ%253D%253D",
    floorPrice: 0.46,
    priceChange: -7.68,
    volumeChange: -6.15,
    volume24h: 0,
    totalVolume: 88.51,
    owners: 2396,
    supply: 9999
  },
  {
    id: "xpsr-24",
    name: "XPSR-24",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGq6uCMJX%252BtGQPmT4YIXAK63G63G8JaZmVbpIxmbhbe%252FGQwRJTRZmnQQQOpLsZDVesRFjFrtyoaB8kQVhmJtZmpD0xk0%252BF5V%252BnvYlX9%252B%252BDW9UG1fNcmMsVX8XH21g%252Fc3TA%253D%253D",
    floorPrice: 0.045,
    priceChange: 2.33,
    volumeChange: -32.30,
    volume24h: 0.04,
    totalVolume: 52.56,
    owners: 2180,
    supply: 4888
  },
  {
    id: "kanpai-pandas-infinity",
    name: "Kanpai Pandas Infinity",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuACv23j29%252BWbT1XMjDrooySmvm3iGM2CW7saddsZfQ1SQIR0O7nDILRG%252B32x7kTtXiq%252FJPzdsgxQbtK3hq0tgAuv0GOnJRW8N9ula65G84FaKoG3hP44ueGDsAYp2G%252B1SgA%253D%253D",
    floorPrice: 2.79,
    priceChange: -3.90,
    volumeChange: 10.73,
    volume24h: 0,
    totalVolume: 25.95,
    owners: 154,
    supply: 250
  },
  {
    id: "cyberkongz",
    name: "CyberKongz",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuALAUsoR6Vj2j2jksAsHzzmG2xZBoxhA%252Bt3hIQRssiTy8qhTI19wqILYa%252B0ddOrjmspVc6NEcDyHGskN%252BO8FtGsmaF3aIeyoBccPHGWW0wWS7LwdYmaAjqyxHUYYt2wYDeeLlgoLv%252FOF5rlbPGcFXvjyVPFUt8yNFSQHzkWMMbWTpb%252F53P9FxmkJOZARWfvyIlA%253D%253D",
    floorPrice: 4.39,
    priceChange: -0.03,
    volumeChange: -4.83,
    volume24h: 0,
    totalVolume: 30214.83,
    owners: 492,
    supply: 1000
  },
  {
    id: "a-kid-called-beast",
    name: "a KID called BEAST",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2F%252BF4uAprNqLw%252FUAbX2wIMCEIQxW%252BSHB4vYxZn%252B9OtGAPKBqgmZFoobToXz5TKujzhfqt48t3abgmNBBr1CpQt%252BiviUmalM4Ay41XaguFYThLgC1Dl%252F6t%252FQ3lEytAO62CD%252F3s6GAXRfjMnB3WGWHuZVI2gO4r8HvefxZBGh85E3sg%253D",
    floorPrice: 0.18,
    priceChange: 7.27,
    volumeChange: 13.32,
    volume24h: 0,
    totalVolume: 19.67,
    owners: 3160,
    supply: 9999
  },
  {
    id: "chimpers",
    name: "Chimpers",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAHHi8sdkiV1ldJ1nW3bLOdwnbetAlklfuHzUMxy0VYpIUG4mXXyhrnvzafjk5unLaalnFRuYaJwbtwzAJ4RxuQXIKWlBzucP7Pp1ZY3%252FAEC3fSC3VCjsCjbyrDa%252BSyxzxw%253D%253D",
    floorPrice: 0.3,
    priceChange: -1.33,
    volumeChange: -10.64,
    volume24h: 0.88,
    totalVolume: 47.36,
    owners: 1819,
    supply: 5554
  },
  {
    id: "proof-of-narnian-nft",
    name: "Proof of Narnian NFT",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAE9Nbq%252Fu4USUod%252FPUAfUD8ztkPUy70Fx06CBInTms1dyLOM8pR1OPTHRUQwRacxc4x724u7IOsFq6DF3qihs6Un0yp5uaN3u3OQFWZjU78N2B5xj7GSNDXEjnooorPIh8g%253D%253D",
    floorPrice: 1.05,
    priceChange: -8.27,
    volumeChange: 1.00,
    volume24h: 0,
    totalVolume: 70.25,
    owners: 2909,
    supply: 3333
  },
  {
    id: "project-aeon",
    name: "Project AEON",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAKM5v2dthdDNgoFYsopVhfVzURJkywvwoWD2Mqe6LjOX7tuGQAgM5S%252Bt0aM%252FBVT8lQcKHr6PpM4cjjaJeE6XnbrvO%252BtcwYMq7iTjNH3tY5uFXLw0k%252Bdylfm%252F5mNiUWjvew%253D%253D",
    floorPrice: 0.75,
    priceChange: -8.77,
    volumeChange: -11.16,
    volume24h: 0,
    totalVolume: 74.81,
    owners: 1132,
    supply: 3332
  },
  {
    id: "boredapekennelclub",
    name: "BoredApeKennelClub",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuANTsUpYsKl0vF26MURe3GYX6rxKkMKpOi6KpGLsca8FkUWScOso1iSieBtuNbAr1eI3dlZph%252BtyBT8o5UGEnq8u10Vym%252FDzrllp5phcsa0lfYV0qrUwh4deg%252Fs3Wk7pzOg%253D%253D",
    floorPrice: 0.49,
    priceChange: -7.37,
    volumeChange: -8.09,
    volume24h: 0,
    totalVolume: 59.76,
    owners: 5243,
    supply: 9602
  },
  {
    id: "degods",
    name: "DeGods",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2FiP3aWzfOlBvWQx7ZVDDwFZajkAUc5SWvTVabagJ1zmtYHaimdPBbMIN76TSwuBRk%252BlNnKdUv%252Fswa2hEiu9zibNMlrXgNaG2nzf7QUcBFT5Cqw81IMr9WIj%252BXoWL64egwf0VE4HAoV8%252Fb4Pls%252BagSPg%253D%253D",
    floorPrice: 0.61,
    priceChange: 0.00,
    volumeChange: -8.13,
    volume24h: 0,
    totalVolume: 46.92,
    owners: 1410,
    supply: 3884
  },
  {
    id: "clonex",
    name: "CloneX",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAG4sCr0QqNBj9PITBHNiyZ9zO7bik7ABC3drusibN0DlR5iBxVe8K2hZyp8CDXsAou7a%252F%252BXwOD4TWfVd4%252BTVNqnjV9KRjQeOL%252B35ch4h8NcQLeHUsyZhCQ9CJSj0mnS3WFrmn240i8EWT%252Bq8i7NSfNIUfQ8k%252FzNrjW%252BrjHv40oyWhaiU7zsIe1LK8MC1OUCbIg%253D%253D",
    floorPrice: 0.19,
    priceChange: 5.40,
    volumeChange: -8.38,
    volume24h: 0.20,
    totalVolume: 79.45,
    owners: 9214,
    supply: 19658
  },
  {
    id: "quirkies-originals",
    name: "Quirkies Originals",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAIZ5vSjP6xd2MBYqPEnuCk70vrBpQhcCSFt4h6ct%252BLJQrDw5hBw3dt6jjV6O9tRR2P%252FeI6x2yJteXWsmtwivQKpcmGJ0LdepAeRE1%252BbRYjpnj6fJ1VSHziOYm%252FSstFRL3A%253D%253D",
    floorPrice: 0.81,
    priceChange: -0.13,
    volumeChange: -3.76,
    volume24h: 0,
    totalVolume: 13.61,
    owners: 1533,
    supply: 4098
  },
  {
    id: "mfer",
    name: "mfers",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGgnJFiQtBG1HMnY1lph%252BByh6D5f1c7ZsaROm9HzMTydWj5%252FXIhq1OyJuLdjvHv9fjJYmlyKj77RVo5i1VNaEecOz6aVfcehZtY25Z%252FEYEQZ19hax5p8Jnk3K4fSW5bfkLPxHjSo80szX%252FtIJ6TLVJNuDApPu0%252F2j08Ljvz6Q5cDv%252FVdxpMPHULMgxcliTu0ag%253D%253D",
    floorPrice: 0.48,
    priceChange: -13.82,
    volumeChange: -26.66,
    volume24h: 0,
    totalVolume: 28.23,
    owners: 5638,
    supply: 10019
  },
  {
    id: "goblintown",
    name: "goblintown.wtf",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGd6UI3HBsOSeAKKFSFlydn6k%252Bt3CygngE9OraCtS4q0zbuqQWw2RSI3dfJzQiPyjy2BhWb9X2qey2SnkG0yl%252FDanJZjedXsJEIcjQ8yQStJVHq0y6pXyj%252Bt9FRvmjh1Q5c7K9qYlxBhmNhGWnoyvvnkJAGDK3ejUS7nMRMBJGyXhXt1sDf%252Bl%252BEcVOAgHHKL7w%253D%253D",
    floorPrice: 0.21,
    priceChange: -26.20,
    volumeChange: -34.58,
    volume24h: 0,
    totalVolume: 26.49,
    owners: 4463,
    supply: 9640
  },
  {
    id: "checks-vv-originals",
    name: "Checks - VV Originals",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAOMkB54uEU23RkOJLLMj1ByA5zx0zalgdMaXHXOQgCmk1kfn41Za4GZH1Lpll5m6YSCHiJelChQgIS9l1lqDyVKKvN0Yk6zgORkU0dvSaPlorUUBRiYe9IBQBRSVInmniQ%253D%253D",
    floorPrice: 0.29,
    priceChange: -4.02,
    volumeChange: -9.17,
    volume24h: 0,
    totalVolume: 15.48,
    owners: 1520,
    supply: 4991
  },
  {
    id: "snackgang",
    name: "SNACKGANG",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2F0Uj6KKjbj84oXdgcjoBOFq75agoYxta3FCa2NxwiA%252BG%252BMat7rkk64PuUsY5xEMucb1m1TFwbtRCexA0oA%252BXnJFQrQCtPTMkAgSKkF3MsFYTAVMLAKQW92If0D9R1YLjtvItQNS7FrGT%252BKGjKUWDWD%252Bop24drw4IgwVtN07m3x5iQKdZ%252F5lvqsMheQF0peQjs",
    floorPrice: 0.04,
    priceChange: -8.45,
    volumeChange: -15.34,
    volume24h: 0.06,
    totalVolume: 21.79,
    owners: 1878,
    supply: 5555
  },
  {
    id: "metawinners",
    name: "MetaWinners",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAIYpev452AQgX6bsora2mDfqbCA6FQBnxqiJV9aYo8jscdOGQKa%252FRbcgqz%252FWmMOp%252BKUiAxDjkHM5vMak7bzsIUcajT5QvX1VRhIPoejurqvja2eBuiE3Ocrv7WrxE8wC4w%253D%253D",
    floorPrice: 0.09,
    priceChange: -10.71,
    volumeChange: -9.09,
    volume24h: 0,
    totalVolume: 56.35,
    owners: 1671,
    supply: 10000
  },
  {
    id: "pirate-nation-founders",
    name: "Pirate Nation - Founders",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAKdftHRzTI662mo5nsiSps36cp1MaIGmnSvducuwUYilqYOMlJ0tlUljToGpaF2E%252FKXTKjwHSPXTslRG%252FoU%252Bp6Hg2CAaiB1%252F7ei9TXZMQia413Ot2MOuv7URA0DpqoYiiA%253D%253D",
    floorPrice: 0.48,
    priceChange: -2.50,
    volumeChange: -17.24,
    volume24h: 0,
    totalVolume: 59.93,
    owners: 2146,
    supply: 9999
  },
  {
    id: "2049-reflections",
    name: "2049 // Reflections",
    image: "https://i.seadn.io/s/raw/files/25518c6fe6f16da297d2b213975d97dc.webp?auto=format&dpr=1&w=3840",
    floorPrice: 0.188,
    priceChange: -6.66,
    volumeChange: -24.57,
    volume24h: 0,
    totalVolume: 43.82,
    owners: 1141,
    supply: 2049
  },
  {
    id: "emby",
    name: "Emby",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuANjTEdw533NtWjhkD0JmidXeo9HqqZs5owjaqnOUGOzp0IeEM9fvvmmY8nbSX2jGLHXEKC%252FGqLTpQlan3zArtbrCCyeeDbjNJLojL3DYwARHjNN5NS20QqEcWWBCLBCGsA%253D%253D",
    floorPrice: 0.178,
    priceChange: 9.00,
    volumeChange: -11.67,
    volume24h: 0,
    totalVolume: 15.87,
    owners: 981,
    supply: 2750
  },
  {
    id: "meebits",
    name: "Meebits",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAOfe0thEa%252BoD5aisdthAZi1WDvyHO16SPaItXP93e82OMyMMIlODoCjcElvZFIG0nFHJ9NjBy3gvzU6Y0et02vdk6cxj5%252Fsh9lbg6OmQvDPecKSJONKqlodGGLXQLQLzTQ%253D%253D",
    floorPrice: 0.75,
    priceChange: -0.07,
    volumeChange: -21.23,
    volume24h: 0,
    totalVolume: 48.18,
    owners: 6411,
    supply: 19999
  },
  {
    id: "mushboomers",
    name: "Mushboomers",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuABwJtUjAVP9W4S%252BBLI3IjTZUKTwd7Q4NllGUaQf5jmeakBNXO9CE2kCSuccDVaMMDWn%252FWmEUYJeffn5f76Z0qP1zgzO2Myvt%252BxYecVAGWecpxevHWsjGODcdum%252F11I2gsQ%253D%253D",
    floorPrice: 0.24,
    priceChange: -0.01,
    volumeChange: -15.54,
    volume24h: 0.42,
    totalVolume: 8.84,
    owners: 366,
    supply: 1240
  },
  {
    id: "digidaigaku",
    name: "DigiDaigaku Genesis",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAK96KWKC5kcWxPz1L2UEqRIYrAmk2hWKYw3P8TB9j9LcNEYuyQ7LpiJ3e31Ye4LdFZ2nOs%252FD6lnUdoYlkFLGtswqKUnvxpISmTLeY8M09EII9y2Twh9md4gJm7gV7boYkw%253D%253D",
    floorPrice: 2.60,
    priceChange: 0.00,
    volumeChange: -24.69,
    volume24h: 0,
    totalVolume: 23.78,
    owners: 638,
    supply: 2022
  },
  {
    id: "my-pet-hooligan",
    name: "My Pet Hooligan ",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAPvJtRx68Cu6NBB7kamJMyXKevirQqvGkKel0NXmlIpOapRUaGQa5atAuwOgI5pcQ0CKJ28rlPy8JWEMNiyf6Zp9q9vd7j1ubkGOZyO5scZ%252B9jW0YhMB6GVp0sh3rIL%252F3mK7Tw8LlAv7tCcSSZFqco53ZcABzujGbpA4WkIqS5U8No%252Bp%252BiEUAeje7XH9K2UmMA%253D%253D",
    floorPrice: 0.25,
    priceChange: -5.34,
    volumeChange: -8.03,
    volume24h: 0,
    totalVolume: 18.89,
    owners: 3387,
    supply: 8888
  },
  {
    id: "moonbirds",
    name: "Moonbirds",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuACY1kzxGDE5QeUXEVsTiFcO8aU%252BfUkRvJdITp%252Bb2DU1yVraPTGb9two4Bi4Wp4Zus8ai1KHmLrO5ltzqpTHAWF9iwkIWhKB9gLr6v4w%252BrZfSosmxWrE5droRqtEfTAZpFw%253D%253D",
    floorPrice: 0.41,
    priceChange: 0.09,
    volumeChange: 10.83,
    volume24h: 0,
    totalVolume: 59.33,
    owners: 5867,
    supply: 9999
  },
  {
    id: "overworld-incarna",
    name: "OVERWORLD INCARNA",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAGdWptlhC4UVqExq%252BIguqyGCu2wSOpJYYdgT4DByYEGee5H4uHuMC6Lrbuq1NqjmaYYuApVRnb%252F9x1CnsNTaU5%252B1BHdFLh1JWlGOMdbqbfzbkXUas%252Fw4L5iomVp0qY6c4g%253D%253D",
    floorPrice: 0.11,
    priceChange: 7.77,
    volumeChange: 7.37,
    volume24h: 0,
    totalVolume: 23.88,
    owners: 1462,
    supply: 6000
  },
  {
    id: "nakamigos",
    name: "Nakamigos",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAL4Jt8Td5eEy1fHJOlfeu%252BGOenJqhAV2PgWTVSkOvo%252F%252FMJuaUXTR2PVAxOr9nDQup4Xbx3%252FvFZ04JWB%252B4hyUJsH7IEVMZi6MQuh%252B16gujAkWhFy9g1oe8LWPDaKxBdAVVQ%253D%253D",
    floorPrice: 0.1,
    priceChange: -1.13,
    volumeChange: -24.31,
    volume24h: 0,
    totalVolume: 31.08,
    owners: 5404,
    supply: 19928
  },
  {
    id: "pixelady-maker",
    name: "Pixelady Maker",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAMhJzzRUB7uZLlC6PR1vTrrcTa7bMJvVsCvWrS63rloh%252B%252FCckp9jp5ayCJF%252F%252BUcOxVH6M9swg08gI%252BcvHqvcZp6ggcXKrgWTZad%252FVWAu6ZgEMYMKLUsE2mP%252F8D98%252FZPCdQ%253D%253D",
    floorPrice: 0.07,
    priceChange: 16.49,
    volumeChange: -13.79,
    volume24h: 0,
    totalVolume: 20.80,
    owners: 2149,
    supply: 7997
  },
  {
    id: "terraforms",
    name: "Terraforms",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAPICt8Z%252Fe5wYtPpQ%252FWTgw8rYezVVcLNOefQBgJPwOvJ5tyOFK5GF2QI5Xs0fecLMrT7c8DVuvqiS2aiKuWIcj%252FNLK6S%252BP8%252F2m1Wh8bgcOgG0ka%252FgowiTRFMjcIyTSl%252B4jw%253D%253D",
    floorPrice: 0.44,
    priceChange: 2.22,
    volumeChange: -3.39,
    volume24h: 0,
    totalVolume: 27.23,
    owners: 2021,
    supply: 9911
  },
  {
    id: "the-plooshies",
    name: "The Plooshies",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAID%252FcT%252FeLngLyuxwSt%252FcUUaoI%252FT2QubgnILkZUldoSehDzzidU7ncLk18ziI3fES8GIRJR2hu%252B%252FTNT4TnLnmP7jHIyr1h8qDfosGP%252FhU%252BDVU689fIl%252BA%252Fvsf2QO7wcWLVw%253D%253D",
    floorPrice: 0.27,
    priceChange: 7.08,
    volumeChange: -11.85,
    volume24h: 0,
    totalVolume: 8.72,
    owners: 804,
    supply: 3333
  },
  {
    id: "killabears",
    name: "KILLABEARS",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAFImrQUzbTyrEcZlBoKtFL8UYK3Y5IIuhgEak%252F7TgSRwGLySQ9F45ooaBbSbGyVJZ72Qo9Ruz2MDMzF0i6vJnYxl0pKWd55F6O2IBc497zsQxL7N6spRRjTk4Va%252FMhPykg%253D%253D",
    floorPrice: 0.18,
    priceChange: -6.66,
    volumeChange: -24.46,
    volume24h: 0,
    totalVolume: 9.68,
    owners: 780,
    supply: 3331
  },
  {
    id: "radbro-webring",
    name: "Radbro Webring",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAJ5%252FrtL4ZOATET26TVm82%252BBh4cvDdSIf5CGx4%252Fqthjp6tkyF%252FmXVhT8U5JkgZbYU%252BBRXdtDlWK%252Fo4FHEbNKHXPR3%252FpH%252BuFqD3T%252FY7jGKnhRGFWT3Pt7li5gTck%252BAfW2sHA%253D%253D",
    floorPrice: 0.08,
    priceChange: 0.81,
    volumeChange: 26.84,
    volume24h: 0,
    totalVolume: 11.22,
    owners: 1466,
    supply: 5000
  },
  {
    id: "v1-cryptopunks-wrapped",
    name: "V1 Cryptopunks (Wrapped)",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAJ3MY1kYovwQFfVldWzDiKQKj0Pi2mcSKb7vtMVYP64buvui24RpHB4wXAr1FrTSiub907fhUlWWSvZCZ8vLzGtQczOESpBGOOn8DYh2UN0O%252BIKVdCbw3J5bKfjF0YOxLuVOjjVAecKTG9UK9tZ5tuC%252B%252BHtoer0vojuWAkDnEQ5Umc1xdTdpY62Kv5l%252FQ%252FuMDg%253D%253D",
    floorPrice: 1.96,
    priceChange: -2.03,
    volumeChange: -3.20,
    volume24h: 0,
    totalVolume: 75.76,
    owners: 1108,
    supply: 5052
  },
  {
    id: "khuga-by-khuga-labs",
    name: "Khuga by Khuga Labs",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuACNJkwKXCtlyCB9QlyxIm2N8wiM%252BIbnjYlsvL%252F29BmMED8aXlgnWCMsUV6B5CrUo0d0%252BuJDHwxUXTfKT0%252BO2SoEndcid%252FzJ%252Bdh6cDHQPZGPsdbuz0iDP86K1VlU%252BgTyUuw%253D%253D",
    floorPrice: 0.034,
    priceChange: 22.22,
    volumeChange: -17.77,
    volume24h: 0.13,
    totalVolume: 5.88,
    owners: 1465,
    supply: 5555
  },
  {
    id: "sugartown-oras",
    name: "Sugartown Oras",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAIntbW3M%252BLdrQ9IBqdAsDlnIyb6uhh3%252FG4e3S7rW1UzKDhxXxMdiMYoj4QOsQi9ZcqBEux3wz5e1UdRf%252FFyxtV71WH0AO69vfbqdbtrELPQL6rBSoxyznCjaWLDQI5jObg%253D%253D",
    floorPrice: 0.082,
    priceChange: 0.27,
    volumeChange: 6.95,
    volume24h: 0,
    totalVolume: 12.12,
    owners: 2098,
    supply: 6905
  },
  {
    id: "the-plague-nft",
    name: "The Plague NFT",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fxodc2gZi85PNDh60glglrYjKmcr5Gr8uk0NfmyxL1UIVwU71T51Fec9wDH4gdlk2hs7PufDQo4Tv0K82s3GkOYIz03i%252FyUwop9l1stxKGH1Q3D5eJYgSDdFmWiSyFfMGK5kcJnFLCzIzsSAyucWUeg%253D%253D",
    floorPrice: 0.143,
    priceChange: -1.47,
    volumeChange: -13.78,
    volume24h: 0,
    totalVolume: 12.58,
    owners: 3527,
    supply: 10725
  },
  {
    id: "rosentica-starfall-travelers",
    name: "Rosentica: Starfall Travelers",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuADUDhkXZQAmThe3YOUxOSawGIR72%252FNfa1%252FqvTMi9hjrlj3EPOAW5X1LI4LueyBvg%252BKQNkoLumPjdZFeQPld9DSizAZz7TvBtD5SZ2eoNfYlcVaSP%252FZafRJ1wUPUEKqv0Ig%253D%253D",
    floorPrice: 0.029,
    priceChange: -20.00,
    volumeChange: 17.77,
    volume24h: 0,
    totalVolume: 6.94,
    owners: 948,
    supply: 5999
  },
  {
    id: "persona",
    name: "Persona",
    image: "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fz9JRSpLYGu7%252BCZoKWtAuAIntbW3M%252BLdrQ9IBqdAsDlkuMpsMyxEk6kBir2ZzWUwNkHv8D2K2%252BiXwUiR03DYvdejWsKgYX%252FawYzocY5aPOPHxQAO29LCmhHnWnjhaVcbGYytbW3Yyx6q190s5MJQkMA%253D%253D",
    floorPrice: 0.1269,
    priceChange: -1.21,
    volumeChange: -10.47,
    volume24h: 0,
    totalVolume: 17.94,
    owners: 1778,
    supply: 8875
  }
];

// Helper function to get static floor price
export const getFloorPrice = (collection) => {
  return collection.floorPrice;
};

// Helper function to get 24h volume with volume change applied
export const get24hVolume = (collection) => {
  const change = 1 + (collection.volumeChange / 100);
  return collection.volume24h * change;
};

// Store generated prices for Lilpudgys
export const lilpudgysPrices = {
  730: '1.75',
  15097: '2.15',
  1768: '2.45',
  16733: '2.85',
  942: '1.95',
  2679: '2.25',
  1593: '2.35',
  15901: '2.65',
  12211: '1.85',
  22083: '2.75',
  3840: '2.05',
  18766: '2.55',
  17286: '3.15',
  17122: '2.95',
  11860: '1.80',
  4517: '2.10',
  14163: '2.30',
  14165: '2.40',
  12227: '2.50',
  6494: '2.60',
  7664: '2.70',
  4823: '2.80',
  3618: '2.90',
  17100: '3.00',
  21308: '3.10',
  12809: '3.20',
  10759: '3.25',
  13570: '3.30',
  2655: '3.35',
  17806: '3.40',
  4249: '3.45',
  6232: '3.50'
};
